// ligfrontend/src/components/Lig/MemberProfile.jsx
import React, { useState } from "react";
import InlineEditor from "../common/InlineEditor";
import AvatarSelector from "../common/AvatarSelector";
import "./MemberProfile.css";

const MemberProfile = ({ member, selectedYear, onUpdateName, onUpdateAvatar }) => {
  return (
    <div className="member-profile">
      <div className="profile-header">
        <InlineEditor
          value={member.name}
          onSave={onUpdateName}
          centerText={true}
          className="profile-name"
        />
      </div>

      <AvatarSelector
        currentAvatar={member.avatar}
        onSelect={onUpdateAvatar}
        editable={true}
      />

      {selectedYear !== undefined && (
        <div className="profile-stats">
          <div className="stat-item">
            <span className="stat-value">{member.yearStats?.[selectedYear] ?? 0}</span>
            <span className="stat-label">Total Notes in {selectedYear}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MemberProfile;
